<div class="purpose-container">
<!--  <div class="purpose-header">-->
<!--    <button mat-icon-button class="back-button" (click)="goBack()">-->
<!--      <mat-icon class="rtl-icon">arrow_back</mat-icon>-->
<!--    </button>-->
<!--  </div>-->

  <div class="purpose-content">
    <h1 class="purpose-title">{{ title }}</h1>

    <div class="options-container">
      <button class="purpose-option" *ngFor="let option of purposeOptions" [class.selected]="option.selected"
        (click)="onOptionChangButton(option)">
        <mat-checkbox [checked]="option.selected" class="option-checkbox" [disableRipple]="true"
          (click)="$event.preventDefault()">
          <div class="option-content">
            <div class="option-title">{{ option.title }}</div>
            <div class="option-description">{{ option.description }}</div>
          </div>
        </mat-checkbox>
      </button>
    </div>
  </div>

  <div class="purpose-footer">
    <button mat-raised-button color="primary" class="proceed-button" [disabled]="!canProceed() || busy" (click)="proceed()">
      {{ busy ? proceedingText : proceedText }}
    </button>
  </div>
</div>
